import { render } from "./ViewEmployeeTimesheet.vue?vue&type=template&id=5e80172e"
import script from "./ViewEmployeeTimesheet.vue?vue&type=script&lang=js"
export * from "./ViewEmployeeTimesheet.vue?vue&type=script&lang=js"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__